export const SET_SORT_BY = 'sortableTable/setSortBy';
export const TOGGLE_IS_SORT_ASCENDING = 'sortableTable/toggleIsSortAscending';
export const RESET_IS_SORT_ASCENDING = 'sortableTable/resetIsSortAscending';
